import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import Modal from '../../../../components/Modal/Modal';
import { SectionButton } from '../../styles/GerenciarContas.styles';
import Button from '../../../../components/Button/Button';
import SelectOptions from '../../../../components/SelectOptions';
import { useMemo, useRef, useState } from 'react';
import { showAlert } from '../../../../store/ducks/sweetAlert';
import * as S from './MakeTransfer.styles';
import { useEffect } from 'react';
import { performMakeTransactionAdmin } from '../../../../store/fetchActions/transactionsActions';
import TextField from '../../../../components/TextField';
import { useTheme } from 'styled-components';
import formatMoney from '../../../../utils/functions/formatMoneyBRL';
import InputFormat from '../InputFormat';
import { accountsApprovedFetchAction } from '../../../../store/fetchActions/userAccounts';
import { Autocomplete } from '@mui/material';

const MakeTransfer = ({ openModal, closeModal, idConta, valorTransacao, descricaoTransacao, transacaoId, isRepasse }) => {
  const theme = useTheme();
  const dispatch = useDispatch();

  const [idContaDestino, setIDContaDestino] = useState();

  const submitTransfer = (data) => {
    const params = {
      ID_CONTA: idConta,
      ID_CONTA_DESTINO: idContaDestino,
      VALOR: data.valor.replace('R$', '').replace(/\s/g, ''),
      DESCRICAO: data.descricao,
      CPFCNPJ_DESTINO: detailAccountsData?.cliente?.CPFCNPJ,
      CPFCNPJ_CLIENTE: usersData?.CPFCNPJ,
      TRANSACTION_IDS: transacaoId ? [transacaoId] : undefined,
      REPASSE: (isRepasse === true) ? 'S' : 'N',
    };
    const valorNumero = data.valor.replace('R$', '').replace(/\./g, '').replace(',', '.').trim();
    if (valorNumero === undefined || valorNumero === 'R$ 0,00' || valorNumero === '0.00') {
      dispatch(
        showAlert({
          title: 'Atenção!',
          text: 'O valor informado , deverá ser maior que 0!',
          icon: 'warning',
        }),
      );
    } else if (valorNumero > detailAccountBalanceData?.saldo) {
      dispatch(
        showAlert({
          title: 'Atenção!',
          text: 'Saldo insuficiente para realizar a transferência!',
          icon: 'warning',
        }),
      );
    } else {
      dispatch(performMakeTransactionAdmin(params, closeModal));
    }
  };

  const submitForm = (data) => {
    submitTransfer(data);
  };

  const { detailAccountBalanceData, detailAccountsData } = useSelector((state) => state.account);
  const { loading } = useSelector((state) => state.spreadTransaction);

  const { usersData } = useSelector((state) => state.user);
  const { accountsData = [] } = useSelector((selector) => selector.accounts || {});
  const accountsApproved = useSelector((state) => state.userAccounts?.approvedAccountsData || []);

  const { handleSubmit: handleBlockUser, control: controlBlockUser, setValue } = useForm({});

  const contas = useMemo(() => {
    if (!accountsApproved || !Array.isArray(accountsApproved)) return [];
    return accountsApproved.map((val) => {
      return { ID: val.ID, NOME: `${val.ID} - ${val.NOME} - ${val.CONTA}` };
    });
  }, [accountsApproved]);

  useMemo(() => {
    return accountsData?.filter((val) => {
      setValue('id', val.ID);
    });
  }, [idContaDestino]);

  useEffect(() => {
    dispatch(accountsApprovedFetchAction({ PAGE: 1, LIMIT: 1000 }));
  }, [dispatch]);

  useEffect(() => {
    if (valorTransacao) {
      setValue('valor', valorTransacao);
    }
    if (descricaoTransacao) {
      setValue('descricao', descricaoTransacao);
    }
  }, [valorTransacao, descricaoTransacao, setValue]);

  const autoC = useRef(null);

  return (
    <Modal open={openModal} close={closeModal} title={'Realizar Transferência'} width={'40vw'}>
      <S.SubTitle>
        <h5>Conta Origem: {detailAccountsData?.conta?.CONTA}</h5>
        <h5>Saldo atual: R$ {formatMoney(detailAccountBalanceData?.saldo, 4)} </h5>
      </S.SubTitle>
      <form onSubmit={handleBlockUser(submitForm)}>
        <S.FormSectionInput>
          <S.ConteinerInput>
            <Autocomplete
              ref={autoC}
              options={contas}
              width={'100%'}
              getOptionLabel={(option) => option.NOME}
              noOptionsText={'Sem opções'}
              onChange={(event, newValue) => {
                setIDContaDestino(newValue?.ID);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Conta Destino"
                  variant="outlined"
                  control={controlBlockUser}
                  name={'autocomplete'}
                />
              )}
            />
          </S.ConteinerInput>
          <S.ConteinerInput>
            <InputFormat
              control={controlBlockUser}
              formatType={'currency'}
              label={'Valor'}
              width={'100%'}
              name={'valor'}
              required={true}
              decimalPlaces={4}
            />
          </S.ConteinerInput>
          <S.ConteinerInput>
            <TextField name={'descricao'} label={'Descrição'} fullWidth multiline={true} control={controlBlockUser} />
          </S.ConteinerInput>
        </S.FormSectionInput>
        <SectionButton>
          <Button
            backgroundcolor={theme.colors.darklimeGreen}
            width={'100%'}
            height={'3.125vw'}
            hoverbgcolor={theme.colors.darklimeGreen}
            hovercolor={theme.colors.white}
            mycolor={theme.colors.white}
            type={'submit'}
            disabled={loading}
          >
            <span>Transferir</span>
          </Button>
        </SectionButton>
      </form>
    </Modal>
  );
};

export default MakeTransfer;
